import axios from "axios";
import * as types from "./auth.actionTypes";
import { mixpanelLoginFunction } from "../../components/utils/mixpanelFunctions";
import { baseUrl } from "../App/app.actions";

const registerRequestAction = () => ({
  type: types.USER_REGISTER_REQUEST,
});

const loginRequestAction = () => ({
  type: types.USER_LOGIN_REQUEST,
});

export const registerAPI = (creds) => (dispatch) => {
  dispatch(registerRequestAction());
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseUrl}/v1/user/register`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(creds),
  };

  return axios
    .request(config)
    .then((res) => {
      // console.log(res);
      return dispatch({ type: types.USER_REGISTER_SUCCESS });
    })
    .catch((err) => {
      // console.log(err.response.data);
      if (err?.response?.data?.email[0] === "This field must be unique.") {
        throw new Error("Email already exists");
      }
      return dispatch({ type: types.USER_REGISTER_FAILED });
    });
};

export const loginAPI = (creds) => (dispatch) => {
  // console.log(creds);
  dispatch(loginRequestAction());
  return axios
    .post(`${baseUrl}/v1/user/login`, creds)
    .then((res) => {
      if (res.data.message === "Invalid Credentials") throw new Error("Invalid Credentials");
      localStorage.setItem("token", res.data.auth_token);
      localStorage.setItem("isAuth", true);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      // console.log(res.data);
      dispatch({ type: types.USER_LOGIN_SUCCESS, payload: res.data });
      mixpanelLoginFunction(res?.data?.user); // mixpanel login fuction
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: types.USER_LOGIN_FAILED, payload: err });
    });
};

export const logoutAPI = () => (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("isAuth");
  localStorage.removeItem("email");
  localStorage.removeItem("user");
  dispatch({ type: types.USER_LOGOUT });
};
